<script lang="ts">
  import type { HTMLAttributes } from 'svelte/elements';
  import * as Icons from 'lucide-svelte';
  import Navigation from '../components/navigation/Navigation.svelte';
  import NavPoint from '../components/navigation/NavPoint.svelte';
  import type { NavPoints } from '../components/navigation/navigation.types';
  import type { NavigationVariant } from '../services/NavigationService.svelte';

  interface Props extends HTMLAttributes<HTMLElement> {
    variant?: NavigationVariant;
  }

  const { variant, ...toNext }: Props = $props();

  const TestNavigation: NavPoints = {
    n001: {
      label: 'This is a long text',
      icon: 'save',
      href: '/#Eins',
    },
    n002: {
      label: 'DWC',
      href: 'https://www.dwc.gmbh',
      active: true,
      sub: {
        n002_001: { label: 'Sub Eins', icon: Icons.Calculator, href: '/#SubEins' },
        n002_002: { label: 'Sub Zwei', icon: Icons.Sticker, active: true },
        n002_003: { label: 'Sub Disabled', icon: Icons.Music },
        n002_004: { label: 'Sub Vier', icon: Icons.Brush, href: '/#SubVier' },
      },
    },
    n003: {
      label: 'Drei',
      href: '/#Drei',
    },
    n004: {
      label: 'Vier',
      href: '/#Vier',
      icon: Icons.User,
    },
    n005: {
      label: 'Point With Sub',
      icon: Icons.Archive,
      href: '/#PontWithSub',
      sub: {
        n004_001: { label: 'Gamma Eins', icon: Icons.Worm, href: '/#GammaEins' },
        n004_002: { label: 'Gamma Zwei', icon: Icons.Cast, href: '/#GammaZwei' },
      },
    },
    n006: {
      label: 'Disabled With Sub',
      icon: Icons.Archive,
      sub: {
        n005_001: { label: 'Beta Eins', icon: Icons.Archive, href: '/#BetaEins' },
        n005_002: { label: 'Beta Zwei', icon: Icons.Archive, href: '/#BetaZwei' },
      },
    },
  };
</script>

<nav {...toNext} class="LayoutNavigation" aria-label="Hauptnavigation">
  <Navigation {variant} points={TestNavigation}>
    <NavPoint icon={Icons.Heart} href="">This is a very long disabled point!</NavPoint>
  </Navigation>
</nav>

<style lang="scss">
  @use '../../styles/display';
  @use '../../styles/mixins';

  .LayoutNavigation {
    --nav-inset-y: 0.7rem;
    --nav-inset-x: 0.75rem;

    @include mixins.greaterNav() {
      --nav-inset-y: 0.25rem;
      --nav-inset-x: 0.5rem;
    }

    :global(.layer1) {
      --nav-border-radius: calc(var(--border-radius) / 2);
      --nav-margin-top: calc(var(--outset-abs) / 2);
      --nav-box-shadow-hover: var(--box-shadow-basic);
      --nav-border-color-hover: var(--border-basic-color);
    }

    :global(.layer2) {
      --nav-font-size: 0.75rem;
      --nav-margin-left: 1rem;
      --nav-border-radius: calc(var(--border-radius) / 4);
      --nav-margin-top: calc(var(--outset-abs) / 4);
      --nav-margin-top-first: calc(var(--outset-abs) / 2);
    }
  }
</style>
